module.exports = __webpack_public_path__ + "img/fengmian.5bcd0daa.jpeg";